import { apiSlice } from "../../app/api/apiSlice";

export const sessionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // Get all active sessions for the current user
        getActiveSessions: builder.query({
            query: () => ({
                url: '/sessions',
                method: 'GET'
            }),
            providesTags: ['Sessions'],
            transformResponse: (response) => {
                // Sort sessions by login time (current session first, then newest)
                const sortedSessions = response.sessions.sort((a, b) => {
                    if (a.isCurrent) return -1;
                    if (b.isCurrent) return 1;
                    return new Date(b.issuedAt) - new Date(a.issuedAt);
                });
                
                return {
                    ...response,
                    sessions: sortedSessions
                };
            }
        }),
        
        // Revoke a specific session
        revokeSession: builder.mutation({
            query: (tokenId) => ({
                url: '/sessions/revoke',
                method: 'DELETE',
                body: { tokenId }
            }),
            invalidatesTags: ['Sessions'],
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.data
        }),
        
        // Revoke all other sessions (keep current)
        revokeAllOtherSessions: builder.mutation({
            query: () => ({
                url: '/sessions/revoke-others',
                method: 'DELETE'
            }),
            invalidatesTags: ['Sessions'],
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.data
        })
    })
});

export const {
    useGetActiveSessionsQuery,
    useRevokeSessionMutation,
    useRevokeAllOtherSessionsMutation
} = sessionsApiSlice;
